// TODO: to be removed with PAY_3067_ENHANCE_MILEAGE_EXPENSE_ITEMS
// LEGACY MILEAGE-LOCK group; see RequestMileageConfiguration.ts
import { type CurrencyRepository } from '@webapp/core/data-access/repositories/CurrencyRepository/CurrencyRepository'
import { HttpError } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type ExpenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository/ExpenseRepository'
import { type RequestMileageConfigurationConstructor } from '@webapp/modules/expense/entities/RequestMileageConfiguration'

interface Dependency {
  expenseRepository: ExpenseRepository
  currencyRepository: CurrencyRepository
}

export class GetMileageLockSettingUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = async (): Promise<
    Nullable<RequestMileageConfigurationConstructor>
  > => {
    const settings = await this.deps.expenseRepository.getMileageLockSetting()
    if (settings == null) return null

    try {
      const currency = await this.deps.currencyRepository.getCurrency(
        settings.currencyId
      )
      return {
        rate: settings.rate,
        currency,
        isLocked: settings.isLocked,
      }
    } catch (err) {
      // Locked currency cannot be resolved (e.g. deleted / inaccessible) —
      // behave as if no lock is configured rather than rendering a half-
      // resolved entity or surfacing a hard error to the user.
      if (err instanceof HttpError) return null
      throw err
    }
  }
}
